<app-feedback-message
  iconType="search"
  title="No reports found"
  [textLines]="[
    'There are no reports found under the current tab.',
    'Please navigate to another tab.'
  ]"
></app-feedback-message>
